import { GoogleLogin } from '@react-oauth/google';
import Alert from '../../../components/alert/Alert';
import { useState } from 'react';
import { repository } from '@whizz/api-client';
import { useLocalStorage } from 'react-use';
import { ADMIN_BEARER_NAME } from '../../../util/vars';

export default function LoginPageComponent() {
  const [ , setAdminBearer ] = useLocalStorage<string | null>(ADMIN_BEARER_NAME, null, { raw: true });
  const [ error, setError ] = useState<string | null>(null);

  return (
    <>
      <div
        className="w-full h-full flex flex-col"
        onClick={(event) => event.stopPropagation()}
      >
        <div className={'w-full mt-10'}>
          {null !== error && (
            <Alert
              show
              type={'error'}
              className={'w-1/2 mx-auto'}
            >
              {error}
            </Alert>
          )}
        </div>

        <div className={'w-full mt-10 flex items-center justify-center'}>
          <GoogleLogin
            onSuccess={(response) => {
              repository.AdminRepository.googleLogin(response)
                .then((response) => {
                  setAdminBearer(response.jwt);

                  // history.push() doesn't work, so we will reload and Router will redirect to homepage
                  window.location.reload();
                })
              ;
            }}
            onError={() => setError('There was an error. Please try again.')}
          />
        </div>
      </div>
    </>
  );
}
